export default "__VITE_ASSET__lOACjGLW__"